import React from "react";
import moment from "moment";
import { Form } from "antd";
import { CompanyInfo } from "./formSecrions/CompanyInfo";
import { BankInfo } from "./formSecrions/BankInfo";
import { LicenseInfo } from "./formSecrions/LicenseInfo/LicenseInfo";

class LicenseeInfo extends React.Component {
  render() {
    const { form, isEditable, dadataBankSelected, companyInfo } = this.props;
    return (
      <div className="card-info">
        <Form layout="inline">
          <div className="offer-card__section" style={{ paddingTop: 0 }}>
            <LicenseInfo form={form} companyInfo={companyInfo} />
            <CompanyInfo form={form} disabled={!isEditable} />
            <BankInfo
              form={form}
              disabled={!isEditable}
              dadataBankSelected={dadataBankSelected}
            />
          </div>
        </Form>
      </div>
    );
  }
}

class LicenseeInfoData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {}
    };
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.isEditable !== this.props.isEditable) {
      this.initEditing();
    }
  }
  componentDidMount() {
    this.initEditing();
  }
  getValueByFieldName(name, val) {
    if (name.includes("Date")) {
      return (val && moment(val)) || null;
    } else {
      return val;
    }
  }
  saveFormRef = formRef => {
    if (formRef && formRef.props && formRef.props.form) {
      this.formRef = formRef.props.form;
    } else {
      this.formRef = null;
    }
    this.props.setForm(this.props.name, this.formRef);
  };

  initEditing = () => {
    let { isEditable } = this.props;
    let dataProps = this.props.data;
    if (isEditable) {
      let newEditData = {};
      if (dataProps) {
        Object.keys(dataProps).forEach(item => {
          newEditData[item] = {
            value: dataProps[item]
          };
        });
      }
      this.setState({ data: newEditData });
    }
  };

  handleFieldsChange = values => {
    this.setState({
      data: {
        ...this.state.data,
        ...values
      }
    });
  };
  render() {
    const { isEditable } = this.props;
    const data = isEditable
      ? this.state.data
      : this.props.data || this.defaultProfileData;
    return (
      <FormLicenseeInfo
        {...this.props}
        data={data}
        wrappedComponentRef={this.saveFormRef}
        getValueByFieldName={this.getValueByFieldName}
        handleFieldsChange={this.handleFieldsChange}
      />
    );
  }
}

const FormLicenseeInfo = Form.create({
  name: "formLicenseeInfo",
  onFieldsChange(props, changedFields) {
    props.handleFieldsChange(changedFields);
  },
  mapPropsToFields(props) {
    let obj = {};
    props.data &&
      Object.keys(props.data).forEach(name => {
        let all = true;
        if (name === "bankAccount") {
          let banks = props.isEditable
            ? props.data[name].value
            : props.data[name];
          banks &&
            banks.forEach((item, idx) => {
              Object.keys(item).forEach(name => {
                obj[name + idx] = Form.createFormField({
                  value: props.isEditable
                    ? item.value
                      ? item.value
                      : item[name]
                    : item[name]
                });
              });
            });
        }
        if (all) {
          obj[name] = Form.createFormField({
            ...(props.isEditable ? props.data[name] : {}),
            value: props.getValueByFieldName(
              name,
              props.isEditable ? props.data[name].value : props.data[name]
            )
          });
        }
      });
    return obj;
  },
  onValuesChange(props, values) {}
})(LicenseeInfo);

export default LicenseeInfoData;
